import Constant from '@/const';
import axios from 'axios';

const getCheckAvail = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/master/laboratory/avail/${id}`),
    );
    return response.data.data;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getCheckAvail;
